import React from "react";
import { useCallback } from "react";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { mutateErrors } from "../../../utils";
import PageHeader from "../../../components/PageHeader";
import useUserQueries from "../hooks/useUserQueries";
import { Paper } from "@material-ui/core";
import { Routes } from "../../../constants/routes";
import { FORM_ERROR } from "final-form";
import { useHistory } from "react-router";
import { useSnackbar } from "notistack";
import { Form } from "react-final-form";
import StudentForm from "../components/StudentForm";
import { createStudentFormValidator } from "../validators/createStudent";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    padding: theme.spacing(3),
  },
}));

export default function StudentsPage() {
  const classes = useStyles();
  const { fetchCreateStudent } = useUserQueries();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const create = useCallback(
    async (data) => {
      try {
        await fetchCreateStudent(data);
        history.push(`/0/${Routes.USER_STUDENTS}`);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [fetchCreateStudent],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Add Student"}
          subtitle={"Here you can add students"}
        />
      </Container>

      <Container maxWidth="md" className={classes.container}>
        <Paper className={classes.paper}>
          <Form
            onSubmit={create}
            validate={createStudentFormValidator}
            component={StudentForm}
          />
        </Paper>
      </Container>
    </>
  );
}
